import type { HTMLAttributes, ReactNode } from 'react';
import clsx from 'clsx';

export interface CardProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
  interactive?: boolean;
  elevated?: boolean;
  noPadding?: boolean;
  className?: string;
}

export function Card({
  children,
  interactive = false,
  elevated = false,
  noPadding = false,
  className,
  ...rest
}: CardProps) {
  return (
    <div
      className={clsx(
        'vania-glass-card',
        {
          'vania-glass-card--interactive': interactive,
          'vania-glass-card--elevated': elevated,
          'vania-glass-card--no-padding': noPadding,
        },
        className
      )}
      {...rest}
    >
      {children}
    </div>
  );
}
